import React from 'react'
import BlogPost from './BlogPost'

export default function Connections() {
  return (
    <BlogPost
      translationKey="connections"
      seoTitle="Connections | Hyunjin Jae"
      seoDescription="Connect with Hyunjin Jae - Professional network, social media profiles, and contact information"
      seoKeywords="Hyunjin Jae, connections, professional network, social media, contact, blog"
      seoTags={['connections', 'network', 'social media', 'contact', 'blog', 'hyunjin jae']}
    />
  )
} 